import moment from "moment";
import React from "react";
import DatePicker from "react-datepicker";
import { YEARS, MONTHS } from "../consts";

const CustomDatePicker = ({
  selectedDate,
  handleDateChange = () => {},
  validateDateChange = () => {},
  className,
  disabled,
  maxDate = moment().subtract(18, "years").toDate(),
  minDate = moment().subtract(120, "years").toDate(),
}) => {
  return <DatePicker
    type="text"
    selected={moment(selectedDate).isValid() ? moment(selectedDate, "YYYY-MM-DD").toDate() : null}
    placeholderText="mm/dd/yyyy"
    dateFormat="MM/dd/yyyy"
    wrapperClassName="w-full"
    className={className}
    disabled={disabled}
    onChange={handleDateChange}
    onBlur={validateDateChange}
    maxDate={maxDate}
    minDate={minDate}
    renderCustomHeader={({
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
    }) => (
      <div className="flex justify-center items-center space-x-2 text-md py-2">
        <button
          className="focus:outline-none text-gray-600 hover:text-black"
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          <i className="fa fa-angle-left" />
        </button>
        <select
          value={moment(date).year()}
          onChange={({ target: { value } }) => changeYear(value)}
        >
          {YEARS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select
          value={MONTHS[moment(date).month()]}
          onChange={({ target: { value } }) =>
            changeMonth(MONTHS.indexOf(value))
          }
        >
          {MONTHS.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <button
          type="button"
          className="focus:outline-none text-gray-600 hover:text-black"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          <i className="fa fa-angle-right" />
        </button>
      </div>
    )}
  />;
};

export default CustomDatePicker;